import { useApplicationContext } from '@/core/hooks/useApplicationContext';
import { Company } from '@/modules/company/entities/interfaces/company';
import { COMPANY_CONFIG_NAME } from '@/modules/company/entities/enums/company';

interface IUseCompany {
  company: Company;
  companyId: string | null;
  setCompany: (company: Company) => void;
  getAllCompanyConfigsByKey: (key: COMPANY_CONFIG_NAME) => string[];
  getFirstCompanyConfigByKey: (key: COMPANY_CONFIG_NAME) => string | undefined;
  hasCompanyConfig: (key: COMPANY_CONFIG_NAME) => boolean;
  hasSettingsDataMatchingDefaultLayout: () => boolean;
}

const useCompany = (): IUseCompany => {
  const {
    company,
    companyId,
    setCompany,
    getAllCompanyConfigsByKey,
    getFirstCompanyConfigByKey,
    hasCompanyConfig,
    hasSettingsDataMatchingDefaultLayout,
  } = useApplicationContext();

  return {
    company,
    companyId,
    setCompany,
    getAllCompanyConfigsByKey,
    getFirstCompanyConfigByKey,
    hasCompanyConfig,
    hasSettingsDataMatchingDefaultLayout,
  };
};

export default useCompany;
